import { Text, Popconfirm } from '@frontend/legacy-components';

import { pluralize } from 'utils/stringUtils';

export interface ReplacePopconfirmProps {
  itemCount: number;
  onConfirm: () => void;
  children: React.ReactNode;
}

export const ReplacePopconfirm = ({
  itemCount,
  onConfirm,
  children,
}: ReplacePopconfirmProps) => {
  return (
    <Popconfirm
      title={`Replace discounts on ${pluralize('item', itemCount)}?`}
      label={
        <>
          <Text>Existing discounts will be removed.</Text>
          <Text>This can&apos;t be undone.</Text>
        </>
      }
      confirmProps={{
        colorScheme: 'destructive',
        children: 'Replace Discounts',
      }}
      onConfirm={onConfirm}
    >
      {children}
    </Popconfirm>
  );
};
